<script>

  import ArticlesList from '@/components/ArticlesList'

  export default {
    components: {
      ArticlesList
    },
    scrollToTop: false
  }
</script>

<template>
  <articles-list />
</template>
